<div class="card" cy-login-card>
  <div class="text-center">
    <div [style.background-image]="'url(' + logoUrl + ')'" class="my-4 mx-auto logo"></div>
    <h3>{{ 'login:title' | translate }}</h3>
    <span>{{ 'login:subtitle' | translate }}</span>
  </div>
  <div class="card-body mt-4" cy-login-card-body>
    <div *ngIf="tokenError" class="alert alert-danger" role="alert">
      {{ tokenError | translate }}
    </div>
    <form (ngSubmit)="login()" [formGroup]="loginForm" novalidate>
      <div class="form-group" cy-login-email-field>
        <label for="inputEmail"
        >{{ 'global:email' | translate }}
          <flabs-required-mark [control]="control('username')"></flabs-required-mark>
        </label>
        <input
          id="inputEmail"
          type="text"
          class="form-control"
          formControlName="username"
          name="email"
          [placeholder]="'global:email-placeholder' | translate"
          [readonly]="!!token"
          (input)="emailInput()"
          autofocus
        />
      </div>
      <div class="form-group" cy-login-password-field>
        <label for="inputPassword"
        >{{ 'global:password' | translate }}
          <flabs-required-mark [control]="control('password')"></flabs-required-mark>
        </label>
        <input
          id="inputPassword"
          type="password"
          class="form-control"
          formControlName="password"
          name="password"
          [placeholder]="'global:password-placeholder' | translate"
        />
      </div>

      <div *ngIf="userStatus === 'invalid'" class="alert alert-danger" role="alert">
        {{ 'global:invalid:username-or-password' | translate }}
      </div>

      <div *ngIf="userStatus === 'locked'" class="alert alert-danger"
           role="alert">{{ 'global:locked-account' | translate }}
      </div>

      <div *ngIf="userStatus === 'blocked'" class="alert alert-danger"
           role="alert">{{ 'global:blocked-account' | translate }}
      </div>

      <div *ngIf="!(loginForm.invalid && submitted) && isLoggedOut && !loginForm.touched" class="alert alert-success"
           role="alert">
        {{ 'login:logged-out:success' | translate }}
      </div>

      <div *ngIf="!(loginForm.invalid && submitted) && isSessionExpired && !loginForm.touched"
           class="alert alert-danger" role="alert">
        {{ 'login:session-expired' | translate }}
      </div>

      <flabs-loader-button
        buttonType="submit"
        [text]="'login:title' | translate"
        className="btn btn-secondary btn-block btn-lg mt-2"
        [loading]="pageState.loading"
        [disabled]="pageState.loading"
      ></flabs-loader-button>
      <span class="text-center mt-3 d-block">
        <a [routerLink]="['/forgotten-password']">{{ 'login:forgotten-password' | translate }}</a>
      </span>
      <a class="btn btn-primary btn-block mt-5"
         [routerLink]="['/registration']">{{ 'registration:register-now' | translate }}</a>
    </form>
  </div>
  <div class="copyright d-flex flex-column align-items-center text-center p-4" cy-login-under-card-info>
    <p [innerHTML]="'global:copyright:assettrax' | translate: { year: currentYear }"></p>
    <div class="d-flex align-items-center justify-content-center">
      <a class="flabs-click-links" (click)="openStaticPagesModal('tc')">{{ 'global:terms-conditions' | translate }}</a>
    </div>
  </div>
</div>
